var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loader)?_c('div',[_c('Loader')],1):_vm._e(),(_vm.chartData.seriesData.length)?_c('div',[_c('highcharts',{attrs:{"options":_vm.plotChartData}})],1):_c('div',[_vm._v("No data available in the chart!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }